import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Layout, Typography, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import ParayanaList from './components/ParayanaList';
import ParayanaDetail from './components/ParayanaDetail';
import AnalyticsDashboard from './components/AnalyticsDashboard';

const { Header, Content } = Layout;
const { Title } = Typography;

const PrayerCounterApp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading } = useAuth();

  // Show loading while checking authentication
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        height: '400px'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🕉️</div>
          <div style={{ color: '#FF8C00', fontSize: '16px' }}>Loading...</div>
        </div>
      </div>
    );
  }

  // Only render if user is authenticated (AuthGuard handles this at app level)
  if (!user) {
    return null;
  }

  // Smart back button navigation
  const handleBackClick = () => {
    const currentPath = location.pathname;
    
    // If we're on a parayana detail page (has ID), go back to parayana list
    if (currentPath.match(/^\/apps\/prayer-counter\/[\w-]+$/)) {
      navigate('/apps/prayer-counter');
    }
    // If we're on analytics page, go back to parayana list
    else if (currentPath === '/apps/prayer-counter/analytics') {
      navigate('/apps/prayer-counter');
    }
    // If we're on the main parayana list, go back to app selection
    else if (currentPath === '/apps/prayer-counter' || currentPath === '/apps/prayer-counter/') {
      navigate('/');
    }
    // Default fallback - go to app selection
    else {
      navigate('/');
    }
  };

  // Get appropriate back button text based on current page
  const getBackButtonText = () => {
    const currentPath = location.pathname;
    
    if (currentPath.match(/^\/apps\/prayer-counter\/[\w-]+$/)) {
      return 'Back to List';
    } else if (currentPath === '/apps/prayer-counter/analytics') {
      return 'Back to List';
    } else {
      return 'Back to Apps';
    }
  };

  return (
    <Layout style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(180deg, #FFF8F0 0%, #FFFFFF 100%)' 
    }}>
      <Header style={{ 
        background: 'linear-gradient(135deg, #FF8C00 0%, #FF7F00 100%)',
        padding: '0 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 2px 8px rgba(255, 140, 0, 0.15)',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        height: '60px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            onClick={handleBackClick}
            style={{ 
              color: 'white', 
              fontSize: '14px',
              border: 'none',
              background: 'transparent',
              height: '32px',
              marginRight: '8px'
            }}
          >
            {getBackButtonText()}
          </Button>
          <Title level={3} style={{ 
            color: 'white', 
            margin: 0,
            fontSize: 'clamp(16px, 4vw, 20px)',
            fontWeight: '600'
          }}>
            🕉️ Parayana Counter
          </Title>
        </div>
      </Header>
      <Content style={{ 
        marginTop: '5px',
        padding: '8px 16px',
        minHeight: 'calc(100vh - 5px)',
        background: 'linear-gradient(180deg, #FFF8F0 0%, #FFFFFF 100%)'
      }}>
        <Routes>
          <Route path="/" element={<ParayanaList />} />
          <Route path="/analytics" element={<AnalyticsDashboard />} />
          <Route path="/:parayanaId" element={<ParayanaDetail />} />
          <Route path="*" element={<Navigate to="/apps/prayer-counter" replace />} />
        </Routes>
      </Content>
    </Layout>
  );
};

export default PrayerCounterApp; 